import { configureStore as configureRtkStore } from "@reduxjs/toolkit";
import type { Reducer, UnknownAction } from "redux";
import reducers from "./reducers";
import type { RootState } from "./state";

export type { RootState };

export function configureStore(preloadedState?: Partial<RootState>) {
  const store = configureRtkStore({
    reducer: reducers as Reducer<
      RootState,
      UnknownAction,
      Partial<RootState>
    >,
    preloadedState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [],
          ignoredPaths: []
        }
      })
  });

  const mod = module as NodeModule & {
    hot?: { accept: (path: string, callback: () => void) => void };
  };
  if (mod.hot) {
    mod.hot.accept("./reducers", () => {
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      const next = require("./reducers")
        .default as Reducer<RootState, UnknownAction, Partial<RootState>>;
      store.replaceReducer(next);
    });
  }

  return store;
}

export type AppStore = ReturnType<typeof configureStore>;
export type AppDispatch = AppStore["dispatch"];
